module.exports = __webpack_public_path__ + "assets/img/download-btn-750577a6.png";